import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "account-flyout" }
const _hoisted_2 = { class: "signIn-content" }
const _hoisted_3 = { class: "create_account_title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "/Assets/images/icons-arrows-left.svg",
  alt: "Back",
  title: " Back"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "HeadingParkGray-H6-Bold"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/-/media/Feature/EchoPark/Account/EchoparkLogin/icons-menu-close.svg?iar=0&hash=71047874FD97363EF7670146DBE51D21",
  alt: "Close",
  title: "Sonic Close"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_Flyout = _resolveComponent("Flyout")!

  return (_openBlock(), _createBlock(_component_Flyout, {
    isOpen: _ctx.accountFlyout,
    onClose: $options.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_overlay, {
          "model-value": $props.loading,
          contained: "",
          persistent: "",
          class: "align-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              color: "primary",
              size: "32",
              indeterminate: ""
            })
          ]),
          _: 1
        }, 8, ["model-value"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($props.hasBackNav)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "goback",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navBack')))
                }, _hoisted_5))
              : _createCommentVNode("", true),
            ($props.heading && !$props.hasBackNav)
              ? (_openBlock(), _createElementBlock("h6", _hoisted_6, _toDisplayString($props.heading), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: "create_account_close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.handleClose && $options.handleClose(...args)))
            }, _hoisted_8)
          ]),
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }, 8, ["isOpen", "onClose"]))
}